const form = document.querySelector('form[id^="product-form-template"]');
radioChangeListener()

function addSelectedColor(panneauName, color) {
  let input = form.querySelector(`#${panneauName.toLowerCase()}`);
  
  if (input) {
    input.value = color;
  } else {

    input = document.createElement('input');
    input.type = 'hidden';
    input.id = panneauName.toLowerCase();
    input.name = `properties[${panneauName.replaceAll("_", " ")}]`;
    input.value = color;
    form.appendChild(input);
  }
}

function radioChangeListener() {
  const panneauColorRadios = document.querySelectorAll('input[name^="panneau_color_"]');

  panneauColorRadios.forEach(function(radio) {

    const blockId = radio.id.split('-').pop(); 


    radio.dataset.blockId = blockId;


    const label = document.querySelector(`label[for="${radio.id}"]`);
  });

  panneauColorRadios.forEach(function(radio) {
    radio.addEventListener("change", function() {
      panneauColorRadios.forEach(function(r) {
        const label = document.querySelector(`label[for="${r.id}"]`);
        if (label) {
          label.classList.remove('active');
        }
      });

      const selectedLabel = document.querySelector(`label[for="${this.id}"]`);
      if (selectedLabel) {
        selectedLabel.classList.add('active');
      }


      const selectedColor = this.value;
      const blockId = this.dataset.blockId;
      

      const legendSpan = document.querySelector(`#selected-panneau_color_${blockId}`);
      if (legendSpan) {
        legendSpan.textContent = selectedColor;
      }
      const parentElement = legendSpan.parentElement;
      const parentText = parentElement.innerText;
      const textBeforeColon = parentText.split(":")[0]; 
      addSelectedColor(textBeforeColon.replaceAll(" ", "_"), this.value)
    });
  });
};
